import React, { useEffect, useState } from 'react';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import websitelogo from '../../../../assets/logos/websitelogo.svg';

import { Box, CssBaseline, Grid, Typography } from '@mui/material';

import { useNavigate, Link } from 'react-router-dom';

import Button from '@mui/material/Button';

import { getPractices, getVisitCount } from '../../../services/api/apiManager';
import { getAccessToken } from '../../../services/Settings';
import { useStateValue } from '../../../services/state/State';
import { actions } from '../../../services/state/Reducer';
const accessToken = `${getAccessToken}`;
function SelectPractice() {
	const defaultTheme = createTheme();
	const [{ practices, practicestats }, dispatch] = useStateValue();
	// const [practices, setPractices] = useState([]);
	const visitcounts = practicestats?.visits || [];
	const navigate = useNavigate();
	const handlepractice = (practice) => {
		// Navigate to the signup page
		dispatch({ type: actions.SET_SELECTED_PRACTICE, payload: practice });
		localStorage.setItem('practice_id', practice?.id);
		localStorage.setItem('prName', practice?.Name);
		localStorage.setItem('OSW_id', practice?.OSW_id);
		localStorage.setItem('OID', practice?.OID);
		navigate('/dashboard');
	};
	const fetchPractices = async () => {
		try {
			const response = await getPractices();
			if (response?.status === 200) {
				// setPractices(response?.data); // Assuming response.data contains the list of practices
				dispatch({ type: actions.SET_PRACTICES, payload: response?.data });
			} else {
				// setPractices([]);
				dispatch({ type: actions.SET_PRACTICES, payload: [] });
			}
		} catch (error) {
			console.error('Error fetching practices:', error);
		}
	};
	const fetchvisitcounts = async () => {
		try {
			const response = await getVisitCount();
			if (response?.status === 200) {
				// setvisitcounts(response?.data?.visits);
				dispatch({ type: actions.SET_PRACTICE_STATS, payload: response?.data });
			} else {
				// setvisitcounts([]);
				dispatch({ type: actions.SET_PRACTICE_STATS, payload: [] });
			}
		} catch (error) {
			console.error('Error fetching practices count:', error);
		}
	};
	useEffect(() => {
		fetchPractices();
		fetchvisitcounts();
	}, []);
	return (
		<ThemeProvider theme={defaultTheme}>
			<CssBaseline />
			<Grid
				container
				component="main"
				sx={{
					height: '100vh',
					backgroundImage: `url(${require('../../../../assets/images/background.png')})`,
					backgroundRepeat: 'no-repeat',
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					padding: '20px 20px',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}
			>
				<Grid
					container
					item
					direction="column"
					xs={12}
					sm={9}
					md={11}
					lg={11}
					xl={9}
					sx={{
						backgroundImage: `url(${require('../../../../assets/images/selectpractice.png')})`,
						backgroundRepeat: 'no-repeat',
						backgroundSize: 'cover',
						objectFit: 'contain',
						backgroundPosition: 'center',
						borderRadius: '15px',
						boxShadow: '0px 1px 15px 0px rgba(255, 255, 255, 0.56)',
						alignItems: 'center',
						padding: '30px 30px',
					}}
				>
					<Grid
						item
						xl={12}
						xs={12}
						sx={{
							display: 'flex',
							// flex: '1',
						}}
					>
						<img
							src={websitelogo}
							alt="Your Alt Text"
							style={{ width: '200px', height: 'auto' }}
						/>
					</Grid>
					<Grid item xl={8} xs={12} mt={1} mb={2}>
						<Typography
							variant="h4"
							sx={{
								color: '#292828',
								fontFamily: 'Poppins',
								fontSize: '25px',
								fontStyle: 'normal',
								fontWeight: '500',
							}}
						>
							Select a Practice To Proceed
						</Typography>
					</Grid>

					<Grid
						container
						item
						justifyContent="center"
						sx={{
							overflow: 'auto',
							height: '430px',
							'@media only screen and (max-width: 1300px) and (min-width: 900px)':
								{
									height: '360px',
								},
							'@media only screen and (max-width: 1920px) and (min-width: 1750px)':
								{
									height: '520px',
								},
						}}
					>
						{practices &&
							practices.map((practice) => (
								<Grid
									item
									container
									lg={3.5}
									xl={3.5}
									md={4}
									sm={8}
									xs={12}
									sx={{ padding: '5px' }}
									key={practice?.id} // Assuming practice has an id
								>
									<Box
										sx={{
											display: 'flex',
											justifyContent: 'center',
											alignItems: 'center',
										}}
									>
										<Button onClick={() => handlepractice(practice)}>
											<Grid
												item
												container
												// alignItems="center"
												sx={{
													borderRadius: '10px',
													border: '1px solid rgba(0, 0, 0, 0.65)',
													background: '#FFF',
													// boxShadow: '0px 1px 20px 0px rgba(0, 0, 0, 0.25)',
													display: 'flex',
													justifyContent: 'center',
												}}
											>
												<Grid item xs={12} lg={12} md={12}>
													<Typography
														variant="body1"
														sx={{
															color: '#292828',
															textAlign: 'center',
															fontFamily: 'Poppins',
															fontSize: '14px',
															fontStyle: 'normal',
															fontWeight: '400',
															whiteSpace: 'nowrap',
															textOverflow: 'ellipsis',
															borderBottom: '1px solid #615959',
															padding: '5px',
															'@media only screen and (max-width: 1920px) and (min-width: 1760px)':
																{
																	// Styles for xs and sm screens
																	fontSize: '17px',
																	fontWeight: '600',
																},
															'@media only screen and (max-width: 1750px) and (min-width: 1500px)':
																{
																	// Styles for xs and sm screens
																	fontSize: '14px',
																	fontWeight: '500',
																},
															'@media only screen and (max-width: 1430px) and (min-width: 900px)':
																{
																	// Styles for xs and sm screens
																	fontSize: '14px',
																	fontWeight: '500',
																},
														}}
													>
														{practice.Name}
														{'-'}
														{practice.id}
													</Typography>
												</Grid>
												<Grid container item sx={{ padding: '10px' }}>
													<Grid container item xs={12}>
														<Grid
															item
															container
															xs={6}
															md={6}
															lg={6}
															xl={6}
															sx={{
																display: 'flex',
																justifyContent: 'center',
																alignItems: 'center',
																padding: '5px',
															}}
														>
															<Grid
																md={12}
																lg={12}
																item
																sx={{
																	borderRadius: '6px',
																	background: '#F6F6F6',
																	background: '#F6F6F6',
																	borderRadius: '8px',
																	padding: '8px 15px',
																}}
															>
																<Typography
																	variant="body2"
																	sx={{
																		color: '#605555',
																		// textAlign: 'center',
																		fontFamily: 'Poppins',
																		fontSize: '12px',
																		fontWeight: '400',
																		whiteSpace: 'nowrap',
																		'@media only screen and (max-width: 1300px) and (min-width: 900px)':
																			{
																				// Styles for xs and sm screens
																				fontSize: '9px',
																				fontWeight: '400',
																			},
																	}}
																>
																	Approved visits
																</Typography>
																<Typography
																	variant="body2"
																	sx={{
																		color: '#1D60C5',
																		textAlign: 'center',
																		fontFamily: 'Poppins',
																		fontSize: '14px',
																		fontWeight: '600',
																		'@media only screen and (max-width: 1300px) and (min-width: 900px)':
																			{
																				// Styles for xs and sm screens
																				fontSize: '10px',
																				fontWeight: '600',
																			},
																	}}
																>
																	{'('}
																	{visitcounts &&
																		(() => {
																			let foundCount = 0;
																			for (const item of visitcounts) {
																				if (
																					item?.id == practice?.id &&
																					item.Status == 'A'
																				) {
																					if (foundCount === 0) {
																						foundCount = item.cnt;
																						break;
																					} else {
																						foundCount = 0;
																						break;
																					}
																				}
																			}
																			return foundCount !== 0 ? foundCount : 0;
																		})()}
																	{')'}
																</Typography>
															</Grid>
														</Grid>
														<Grid
															item
															container
															xs={6}
															md={6}
															lg={6}
															xl={6}
															sx={{
																display: 'flex',
																justifyContent: 'center',
																alignItems: 'center',
																padding: '5px',
															}}
														>
															<Grid
																md={12}
																lg={11}
																item
																sx={{
																	borderRadius: '6px',
																	background: '#F6F6F6',
																	background: '#F6F6F6',
																	borderRadius: '8px',
																	padding: '8px 15px',
																}}
															>
																<Typography
																	variant="body2"
																	sx={{
																		color: '#605555',
																		textAlign: 'center',
																		fontFamily: 'Poppins',
																		fontSize: '12px',
																		fontWeight: '400',
																		'@media only screen and (max-width: 1300px) and (min-width: 900px)':
																			{
																				// Styles for xs and sm screens
																				fontSize: '9px',
																				fontWeight: '400',
																			},
																	}}
																>
																	Draft visits
																</Typography>
																<Typography
																	variant="body2"
																	sx={{
																		color: '#FF7E07',
																		textAlign: 'center',
																		fontFamily: 'Poppins',
																		fontSize: '15px',
																		fontWeight: '600',
																		'@media only screen and (max-width: 1300px) and (min-width: 900px)':
																			{
																				// Styles for xs and sm screens
																				fontSize: '10px',
																				fontWeight: '600',
																			},
																	}}
																>
																	{'('}
																	{visitcounts &&
																		(() => {
																			let foundCount = 0;
																			for (const item of visitcounts) {
																				if (
																					item?.id == practice?.id &&
																					item.Status == 'D'
																				) {
																					if (foundCount === 0) {
																						foundCount = item.cnt;
																						break;
																					} else {
																						foundCount = 0;
																						break;
																					}
																				}
																			}
																			return foundCount !== 0 ? foundCount : 0;
																		})()}
																	{')'}
																</Typography>
															</Grid>
														</Grid>
													</Grid>
													<Grid container item xs={12}>
														<Grid
															item
															container
															xs={6}
															md={6}
															lg={6}
															xl={6}
															sx={{
																display: 'flex',
																justifyContent: 'center',
																alignItems: 'center',
																padding: '5px',
															}}
														>
															<Grid
																md={12}
																lg={12}
																xl={12}
																item
																sx={{
																	borderRadius: '6px',
																	background: '#F6F6F6',
																	background: '#F6F6F6',
																	borderRadius: '8px',
																	padding: '8px 15px',
																}}
															>
																<Typography
																	variant="body2"
																	sx={{
																		color: '#605555',
																		textAlign: 'center',
																		fontFamily: 'Poppins',
																		fontSize: '12px',
																		fontWeight: '400',
																		whiteSpace: 'nowrap',
																		'@media only screen and (max-width: 1300px) and (min-width: 900px)':
																			{
																				// Styles for xs and sm screens
																				fontSize: '9px',
																				fontWeight: '400',
																			},
																	}}
																>
																	Rejected Visits
																</Typography>
																<Typography
																	variant="body2"
																	sx={{
																		color: '#ED2828',
																		textAlign: 'center',
																		fontFamily: 'Poppins',
																		fontSize: '15px',
																		fontWeight: '600',
																		'@media only screen and (max-width: 1300px) and (min-width: 900px)':
																			{
																				// Styles for xs and sm screens
																				fontSize: '10px',
																				fontWeight: '600',
																			},
																	}}
																>
																	{'('}
																	{visitcounts &&
																		(() => {
																			let foundCount = 0;
																			for (const item of visitcounts) {
																				if (
																					item?.id == practice?.id &&
																					item.Status == 'O'
																				) {
																					if (foundCount === 0) {
																						foundCount = item.cnt;
																						break;
																					} else {
																						foundCount = 0;
																						break;
																					}
																				}
																			}
																			return foundCount !== 0 ? foundCount : 0;
																		})()}
																	{')'}
																</Typography>
															</Grid>
														</Grid>
														<Grid
															item
															container
															xs={6}
															md={6}
															lg={6}
															xl={6}
															sx={{
																display: 'flex',
																justifyContent: 'center',
																alignItems: 'center',
																padding: '5px',
															}}
														>
															<Grid
																md={12}
																lg={11}
																item
																sx={{
																	borderRadius: '6px',
																	background: '#F6F6F6',
																	background: '#F6F6F6',
																	borderRadius: '8px',
																	padding: '8px 15px',
																}}
															>
																<Typography
																	variant="body2"
																	sx={{
																		color: '#605555',
																		textAlign: 'center',
																		fontFamily: 'Poppins',
																		fontSize: '12px',
																		fontWeight: '400',
																		'@media only screen and (max-width: 1300px) and (min-width: 900px)':
																			{
																				// Styles for xs and sm screens
																				fontSize: '9px',
																				fontWeight: '400',
																			},
																	}}
																>
																	Billed visits
																</Typography>
																<Typography
																	variant="body2"
																	sx={{
																		color: '#036210',
																		textAlign: 'center',
																		fontFamily: 'Poppins',
																		fontSize: '15px',
																		fontWeight: '600',
																		'@media only screen and (max-width: 1300px) and (min-width: 900px)':
																			{
																				// Styles for xs and sm screens
																				fontSize: '10px',
																				fontWeight: '600',
																			},
																	}}
																>
																	{'('}
																	{visitcounts &&
																		(() => {
																			let foundCount = 0;
																			for (const item of visitcounts) {
																				if (
																					item?.id == practice?.id &&
																					item.Status == 'B'
																				) {
																					if (foundCount === 0) {
																						foundCount = item.cnt;
																						break;
																					} else {
																						foundCount = 0;
																						break;
																					}
																				}
																			}
																			return foundCount !== 0 ? foundCount : 0;
																		})()}
																	{')'}
																</Typography>
															</Grid>
														</Grid>
													</Grid>
												</Grid>
											</Grid>
										</Button>
									</Box>
								</Grid>
							))}
					</Grid>
				</Grid>
			</Grid>
		</ThemeProvider>
	);
}
export default SelectPractice;
